import axios from "axios";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:5000";

const aiAPI = axios.create({
  baseURL: `${API_BASE}/api/ai-chatbot`,
  headers: { "Content-Type": "application/json" },
});

aiAPI.interceptors.request.use((config) => {
  const token = localStorage.getItem("userAccessToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fetchAiPhoneSettings = () => aiAPI.get("/phones");

export const toggleAiForPhone = (phoneId, enabled) =>
  aiAPI.put(`/phones/${phoneId}/toggle`, { ai_enabled: enabled ? 1 : 0 });

export const updateAiKnowledgeBase = (phoneId, knowledgeBase) =>
  aiAPI.put(`/phones/${phoneId}/knowledge-base`, {
    knowledge_base: knowledgeBase,
  });

export const updateAiChatbotSettings = (phoneId, settings) =>
  aiAPI.put(`/phones/${phoneId}/settings`, settings);

export const scrapeWebsite = (url) =>
  aiAPI.post("/scrape-website", { url });

export default aiAPI;


